import { isValidPhoneNumber } from '../../Utils/validation';

export const INVITE_TOKEN_KEY = 'd1.plan.invite_token';

export type InviteStatus = 'HAS_PLAN' | 'INVALID_TOKEN' | 'AT_CAPACITY' | 'OWNER_CANNOT_JOIN' | 'UNKNOWN_ERROR';

const toCanonicalInviteStatus = (reason?: string): InviteStatus => {
  const key = (reason || '').trim().toUpperCase();

  switch (key) {
    case 'AT_CAPACITY':
    case 'GROUP_FULL':
      return 'AT_CAPACITY';

    case 'HAS_PLAN':
    case 'ALREADY_IN_PLAN':
      return 'HAS_PLAN';

    case 'OWNER_CANNOT_JOIN':
    case 'OWNER':
      return 'OWNER_CANNOT_JOIN';

    case 'INVALID_TOKEN':
    case 'INVALID':
    case 'NOT_FOUND':
    case 'EXPIRED':
      return 'INVALID_TOKEN';

    default:
      return 'UNKNOWN_ERROR';
  }
};

export const inviteReasonToHuman = (reason?: string): string => {
  switch (toCanonicalInviteStatus(reason)) {
    case 'HAS_PLAN':
      return 'You already have a plan attached to your account.';
    case 'INVALID_TOKEN':
      return "We couldn't find a plan with that code. Please check and try again.";
    case 'AT_CAPACITY':
      return 'This plan is already full.';
    case 'OWNER_CANNOT_JOIN':
      return 'Plan owners cannot join via their own invite link.';
    case 'UNKNOWN_ERROR':
    default:
      return "We couldn't find a plan with that code. Please check and try again.";
  }
};

export function normalizeUsername(input: string): string {
  if (!input) return '';
  return isValidPhoneNumber(input) ? `+1${input.replace(/\s+|[()-.]/g, '')}` : input.toLowerCase();
}
